module.exports = __webpack_public_path__ + "static/media/vehicle-time.ed407219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshots/vehicle-time.png
// module id = 145
// module chunks = 27